import { CountByAirStatusModel } from "entities/AirSavedCard/model/types";
import { AirStatusesDTO } from "entities/shared/airCard.types";
import { FilterContextType, SeaFilterType, SetAirFilterFunc } from "features/shared/filter.types";
import { AirFilterType } from "features/shared/filter.types";
import { useAirQueryKey } from "features/shared/useAirQueryKey";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { AirWhereQuery, useAirInfiniteScrollFetch } from "entities/AirSavedCard";
import { ValueOf } from "shared/lib/typeCheck.lib";

type UseAirStatusFilterProps = {
  setFilter?: SetAirFilterFunc;
  innerFilterState: FilterContextType["innerFilterState"];
  isAirFilter?: (filter: AirFilterType | SeaFilterType) => filter is AirFilterType;
};

type UseAirStatusFilterReturnType = {
  airStatuses: CountByAirStatusModel[];
  airHandleFilter: (status: ValueOf<typeof AirStatusesDTO>) => void;
};

export const useAirStatusFilter = ({
  setFilter,
  innerFilterState,
  isAirFilter,
}: UseAirStatusFilterProps): UseAirStatusFilterReturnType => {
  const { isCurrentViewFilteredCards, isCurrentViewMain, showFilteredCardsView } = usePanelViews();

  const { queryKey } = useAirQueryKey({
    isCurrentViewFilteredCards,
    isCurrentViewMain,
  });

  const { countByAirStatus: countByStatus } = useAirInfiniteScrollFetch({
    queryKey: [queryKey],
    shouldRequestOnMount: false,
  });

  const handleFilter = (status: ValueOf<typeof AirStatusesDTO>) => {
    if (isAirFilter?.(innerFilterState.filter)) {
      innerFilterState.setWhereQuery((prev: AirWhereQuery) => ({
        ...prev,
        status,
      }));
      setFilter?.({
        ...innerFilterState.filter,
        where: { ...innerFilterState.filter.where, status },
      });
    }
    if (!isCurrentViewFilteredCards) {
      showFilteredCardsView();
    }
  };

  return { airStatuses: countByStatus, airHandleFilter: handleFilter };
};
